import Icon, { IconType } from 'components/Icon';
import { Tooltip } from 'components/Widget/Tooltip';
import { FrameType } from 'dragonmouse-shared/interfaces';
import { MenuItemAction } from 'menu/MenuItem';
import { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getSelectedFrameId, openCanvasWidth } from 'redux/mode/util';
import { RootReducer, selectSelectedFrames } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';
import { ButtonType } from './styles';
import ShareFrameModal from 'components/Modal/Share/ShareFrameModal';
import { trackMiscAction } from 'analytics';

const Island = () => {
	const theme = useTheme();
	const [tooltipIdChat] = useState(String(Math.random()));
	const [tooltipIdShare] = useState(String(Math.random()));
	const [tooltipIdPrototype] = useState(String(Math.random()));
	const [showShareModal, setShowShareModal] = useState(false);

	const { selectedFrameId, selectedFrames, showLabels, showIsland } = useSelector(
		(r: RootReducer) => {
			return {
				selectedFrameId: getSelectedFrameId(r.mode.selected),
				selectedFrames: selectSelectedFrames(r),
				showLabels: openCanvasWidth(r.mode) >= 320,
				showIsland: openCanvasWidth(r.mode) >= 120,
			};
		},
		shallowEqual
	);

	const selectedFrame =
		selectedFrameId && selectedFrames.length === 1
			? selectedFrames.find((f) => f.id === selectedFrameId)
			: null;

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onShowInChatPress = async () => {
		if (selectedFrame && selectedFrame.metadata.sourceChatId) {
			MenuItemAction.createScrollToFrameInChat(
				selectedFrame.metadata.sourceChatId,
				selectedFrame.id
			).callback();
		}
	};

	const onSharePress = async () => {
		if (selectedFrame) {
			trackMiscAction('open_frame_share_modal');
			setShowShareModal(true);
		}
	};
	const onPrototypePress = async () => {
		if (selectedFrameId) {
			MenuItemAction.createOpenPrototype(selectedFrameId).callback();
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	if (!showIsland) return null;
	const canShowInChat =
		selectedFrameId !== null && selectedFrame?.metadata?.sourceChatId !== undefined;
	const canOpenPrototype =
		selectedFrameId !== null && selectedFrame?.metadata?.type !== FrameType.IMPORT;
	return (
		<>
			<S.Base>
				<S.Button
					data-tooltip-id={tooltipIdChat}
					data-tooltip-content="Show selected frame in chat"
					onClick={onShowInChatPress}
					active={canShowInChat}
					buttonType={ButtonType.LEFT}
				>
					<S.Icon>
						<Icon
							type={IconType.CHAT}
							width={14}
							height={14}
							color={canShowInChat ? theme.gray[1000] : theme.gray[400]}
						/>
					</S.Icon>
					{showLabels && (
						<S.Label color={canShowInChat ? theme.gray[900] : theme.gray[400]}>Show chat</S.Label>
					)}
				</S.Button>
				<Tooltip id={tooltipIdChat} placement="top" />
				<S.VerticalLine />
				<S.Button
					data-tooltip-id={tooltipIdShare}
					data-tooltip-content="Share selected frame"
					onClick={onSharePress}
					active={canOpenPrototype}
					buttonType={ButtonType.CENTER}
				>
					<S.Icon>
						<Icon
							type={IconType.SHARE}
							width={14}
							height={14}
							color={canOpenPrototype ? theme.gray[1000] : theme.gray[400]}
						/>
					</S.Icon>
					{showLabels && (
						<S.Label color={canOpenPrototype ? theme.gray[900] : theme.gray[400]}>Share</S.Label>
					)}
				</S.Button>
				<Tooltip id={tooltipIdShare} placement="top" />
				<S.VerticalLine />
				<S.Button
					data-tooltip-id={tooltipIdPrototype}
					data-tooltip-content="View prototype of selected frame"
					onClick={onPrototypePress}
					active={canOpenPrototype}
					buttonType={ButtonType.RIGHT}
				>
					<S.Icon>
						<Icon
							type={IconType.PLAY}
							width={14}
							height={14}
							color={canOpenPrototype ? theme.gray[1000] : theme.gray[400]}
						/>
					</S.Icon>
					{showLabels && (
						<S.Label color={canOpenPrototype ? theme.gray[900] : theme.gray[400]}>
							Prototype
						</S.Label>
					)}
				</S.Button>
				<Tooltip id={tooltipIdPrototype} placement="top" />
				{showShareModal && selectedFrameId && (
					<ShareFrameModal frameId={selectedFrameId} onClose={() => setShowShareModal(false)} />
				)}
			</S.Base>
		</>
	);
};

export default Island;
